import styled from "styled-components"
import { theme } from "Theme"

export const Icon = styled.div`
  text-align: center;
  background: rgba(255, 255, 255, 0.4);
  border-radius: ${theme.borderRadius.elements};
  box-shadow: ${theme.shadow.feature.small.default};
  border: 1px solid #fff;
  width: 56px;
  border-radius: ${theme.borderRadius.elements};
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: space-between;

  .month,
  .year {
    background: #fff;
    color: #000;
    font-size: ${theme.fontSize.smallish};
    padding: 2px;
    width: 100%;
  }
  .day {
    align-items: center;
    color: #fff;
    display: flex;
    font-size: ${theme.fontSize.xlarge};
    font-weight: bold;
    height: 32px;
    justify-content: center;
  }

  @media (min-width: ${theme.breakpoints.s}) {
    min-height: 56px;
    width: 56px;
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`
